<template>
  <div>
    <el-input
        v-model="tempModel"
        autocomplete="off"
        placeholder="请选择人员"
        :disabled="disabled == null ? false : disabled"
        @focus="openPerson"
        @click="openPerson"
    ></el-input>
    <!-- 人员列表弹窗 -->
    <el-drawer
        v-model="dialogFormVisiblePerson"
        title="人员列表"
        size="20%"
        append-to-body
        destroy-on-close
    >
      <div
          class=""
          style="
          margin-top: 16px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
        "
      >
        <el-input
            style="width: 60%; margin-left: 5px"
            v-model="name"
            placeholder="人员名称"
        />
        <el-button type="primary" @click="getStaffAll">查询</el-button>
      </div>
      <el-table
          :data="tableDataPerson"
          style="width: 100%; margin-left: 2.5%; background-color: #e9eef3"
          v-fit-columns
          ref="MultiplePerson"
          border
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="name" label="人员姓名" width="" />
      </el-table>
    </el-drawer>
  </div>
</template>
<script>
import { getStaffAll } from "../../../request/BasicDataApi";

export default {
  name: "single select",

  data() {
    return {
      name: "", //
      list: [],
      tableDataPerson: [],
      dialogFormVisiblePerson: false, //人员弹窗
      // beDepartId: null,
      tempModel: null,
    };
  },
  props: ["model", "disabled", "beDepartId"],
  created() {
    this.getStaffAll();
    this.tempModel = this.model
  },
  methods: {
    getStaffAll() {
      getStaffAll({
        departId: this.beDepartId,
        name: this.name,
        phone: "",
        sex: "",
        jobSitu: "",
        pageNum: 1,
        pageSize: 1000,
      }).then((res) => {
        if (res.code == 0) {
          this.tableDataPerson = res.data.records;
        }
      });
    },
    //选择责任人
    handleCurrentChange(e) {
      this.dialogFormVisiblePerson = false;
    },
    //打开人员列表弹窗
    openPerson() {
      this.dialogFormVisiblePerson = true;
    },
    handleSelectionChange(val) {
      if (this.dialogFormVisiblePerson) {
        let idArr = [];
        let nameArr = [];
        val.forEach((item) => {
          idArr.push(item.id);
          nameArr.push(item.name);
        });
        this.$emit("id", idArr.join(","));
        this.$emit("name", nameArr.join(","));
      }
    },
  },
  watch: {
    beDepartId(e) {
      // this.beDepartId = e;
      getStaffAll({ departId: e, pageNum: 1, pageSize: 10000 })
          .then((res) => {
            if (res.code == 0) {
              this.tableDataPerson = res.data.records;
            }
          })
          .then(() => {
            this.tableDataPerson.forEach((item, index) => {
              item.rowIndex = index;
            });
          });
    },
    dialogFormVisiblePerson(e) {
      if (!e) {
        this.$refs["MultiplePerson"].clearSelection();
      }
    },
    'model'(e){
      this.tempModel =  e
    }
  },
};
</script>

<style scoped>
</style>
